import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Auth } from '@angular/fire/auth';
import { IDatosCuentaBancaria } from "@interfaces/cuentas-bancarias.interface";
import { ISelectedBank } from "@interfaces/seleted-bank.interface";
import { ISolicitudResponse } from "@interfaces/solicitud-cambio-via-pago.response.interface";
import { ITiposBancos } from "@interfaces/tipos-bancos.interface";
import { ITiposCuentasBancarias } from "@interfaces/tipos-cuentas-bancarias.interface";
import { ValidarApiSantanderResponse, ValidarCuentasDigitalesResponse, ValidarRequest } from "@interfaces/validar-cuentas.interface";
import { Util } from "@shared/common/utils/util";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";


@Injectable({ providedIn: 'root' })

export class CambioViaPagoPensionService {


  public token: string = '';

  constructor(
    public firebaseAuth: Auth,
    private readonly http: HttpClient,
    private readonly util: Util
  ) {
  }

  public obtenerBancos(token: string): Observable<ITiposBancos[]> {
    let url = `${environment.BASE_BACKEND}/bancos/tipos-bancos`;
    let headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);
    return this.http.get(url, { headers })
      .pipe(map(resp =>  resp as ITiposBancos[]));
  }

  public obtenerTipoCuentas(token: string): Observable<ITiposCuentasBancarias[]> {
    let url = `${environment.BASE_BACKEND}/bancos/tipos-cuentas-bancarias`;
    let headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);
    return this.http.get(url, { headers })
            .pipe(map(resp => resp as ITiposCuentasBancarias[]))

  }

  public async storeToken(): Promise<void> {
    try {
      const currentUser =  this.firebaseAuth.currentUser;
      const firebasetoken = await currentUser?.getIdToken();
      this.token = String(firebasetoken);

    } catch (error) {
      console.log(' --- Error adquiriendo token ---   ', error);
    }
  }


  public async uid(): Promise<string> {
    try {
      const user = await this.util.getUser();

      if (user) {
        const currentUser: any = this.firebaseAuth.currentUser;

        return currentUser.uid;
      }

      return "";
    } catch (error) {
      console.error('Error obteniendo UID:', error);
      return "";
    }
  }

  public validarCuentasDigitales(request: ValidarRequest, token:string): Observable<ValidarCuentasDigitalesResponse> {
    let url = `${environment.BASE_BACKEND}/client/validar-cuentas-digitales`;
    let headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);

    let body =  request 
    return this.http.post(url, body, { headers }) as Observable<ValidarCuentasDigitalesResponse>;
  }
  
  public validarCuentasBancarias(request: ValidarRequest, token:string): Observable<ValidarApiSantanderResponse> {
    let url = `${environment.BASE_BACKEND}/client/estado-cuenta-corriente`;
    let headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);

    let body =  request;
    return this.http.post(url, body, { headers }) as Observable<ValidarApiSantanderResponse>;
  }

  public datosCuentasBancarias(token:string): Observable<IDatosCuentaBancaria[]> {
    const url = `${environment.BASE_BACKEND}/client/cuentas-bancarias`;
    const headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);
    const body = {};
  
    return this.http.post(url, body, { headers }).pipe(
      map((data: Object) => {
        return (data as IDatosCuentaBancaria[]).sort((a, b) => a.nombreInstitucionFinanciera.localeCompare(b.nombreInstitucionFinanciera));
      })
    );
  }

  public solicitudCambioViaPago(token:string, selectedBank: ISelectedBank): Observable<ISolicitudResponse> {
    const url = `${environment.BASE_BACKEND}/client/solicitud-cambio-via-pago`;
    const headers = this.util.getHeaders(token);
    const body = selectedBank;
  
    return this.http.post(url, body, { headers }) as Observable<ISolicitudResponse>;
  }

 


}